import { useEffect, useRef, useState } from "react";
import config from "../config"; // Ensure this config file exists and has apiBasePath

const MAX_RETRIES = 5;

export default function usePromptSocket() {
    const [socketStatus, setSocketStatus] = useState("Connecting...");
    const [reconnectAttempts, setReconnectAttempts] = useState(0);
    const socketRef = useRef(null);

    const connectPromptSocket = () => {
        // Ensure config.apiBasePath is defined and accessible
        const socketUrl = `${config.apiBasePath}/api/v1/inference/prompt`;
        const socket = new WebSocket(socketUrl);
        socketRef.current = socket;

        socket.onopen = () => {
            console.log("✅ Prompt WebSocket Connected");
            setSocketStatus("Connected");
            setReconnectAttempts(0); // Reset attempts on successful connection
        };

        socket.onmessage = (event) => {
            console.log("📨 Prompt WebSocket message:", event.data);
            // You would typically parse event.data here (e.g., JSON.parse)
            // and update state or trigger other actions based on the message.
        };

        socket.onerror = (error) => {
            console.error("🚨 Prompt WebSocket error:", error);
            setSocketStatus("Error");
            // Consider more specific error handling or UI feedback for the user
        };

        socket.onclose = (event) => {
            console.warn(`🔌 Prompt WebSocket closed. Code: ${event.code}, Reason: ${event.reason}`);
            setSocketStatus("Disconnected");

            if (reconnectAttempts < MAX_RETRIES) {
                const delay = Math.pow(2, reconnectAttempts) * 1000; // Exponential backoff
                setReconnectAttempts((prev) => prev + 1);
                setSocketStatus(`Reconnecting (${reconnectAttempts + 1}/${MAX_RETRIES})...`);
                // setTimeout(connectPromptSocket, delay);
            } else {
                setSocketStatus("Failed to reconnect after multiple attempts. Please refresh or check connection.");
            }
        };
    };

    useEffect(() => {
        connectPromptSocket();
        return () => {
            // Clean up: close the WebSocket connection when the component unmounts
            socketRef.current?.close();
        };
    }, []); // Empty dependency array ensures this runs once on mount and cleans up on unmount

    return {
        promptSocket: socketRef.current,
        socketStatus,
        connectPromptSocket, // Expose the function to manually reconnect if needed
    };
}
